import extractHttpUrl from './extractHttpUrl.ts';
import toDataUrl from './toDataUrl.ts';

/**
 * Converts HTTP background-image URLs on inline-styled elements to data URLs.
 * Snapdom preserves inline background-image URLs on cloned elements, but those
 * HTTP URLs are unresolvable inside snapdom's SVG data: rendering context.
 * Backgrounds that no longer exist upstream are cleared so nothing is drawn in their place.
 */
const preloadBackgroundImages = (element: HTMLElement): Promise<PromiseSettledResult<void>[]> => {
  const elements = [element, ...Array.from(element.querySelectorAll<HTMLElement>('*'))].filter(
    (el) => {
      const bg = el.style?.backgroundImage;
      return bg && bg !== 'none' && bg !== 'initial' && bg !== '';
    }
  );

  const tasks = elements.map(async (el) => {
    const url = extractHttpUrl(el.style.backgroundImage);
    if (!url) return;
    const dataUrl = await toDataUrl(url);
    el.style.backgroundImage = dataUrl === null ? 'none' : `url("${dataUrl}")`;
  });

  return Promise.allSettled(tasks);
};

export default preloadBackgroundImages;
